import React from 'react';
import SIcon from './SIcon';
import { faLightbulbExclamation } from '@fortawesome/pro-solid-svg-icons';

const Icon = props => <SIcon {...props} icon={faLightbulbExclamation} fa />;

export default Icon;
